import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { failPayment } from "../api/payment";

/** 토스 결제창에서 사용자가 취소/이탈했거나 인증에 실패했을 때 돌아오는 콜백 페이지(failUrl). */
export default function CheckoutFailPage() {
  const [params] = useSearchParams();
  const [message, setMessage] = useState("결제가 취소되었습니다.");

  useEffect(() => {
    const orderId = params.get("orderId");
    const failMessage = params.get("message");
    if (failMessage) {
      setMessage(failMessage);
    }
    if (orderId) {
      // 재고를 즉시 복원한다 (실패해도 사용자에게는 별도로 알리지 않는다 - 이미 실패 안내 중이므로).
      failPayment(orderId).catch(() => {});
    }
  }, [params]);

  return (
    <div className="page checkout-result-page">
      <h1 className="page-title">결제가 완료되지 않았습니다</h1>
      <p className="error">{message}</p>
      <Link to="/cart" className="link-btn">장바구니로 돌아가기</Link>
    </div>
  );
}
